export class LeadModel {
  createdAt: Date;
  nome: string;
  empresa: string;
  email: string;
  telefone: string;

  protected constructor(
    nome: string,
    empresa: string,
    email: string,
    telefone: string
  ) {
    this.createdAt = new Date();
    this.nome = nome;
    this.empresa = empresa;
    this.email = email;
    this.telefone = telefone;
  }

  static build({
    nome,
    empresa,
    email,
    telefone,
  }: {
    nome?: string;
    empresa?: string;
    email?: string;
    telefone?: string;
  }) {
    if (!nome) throw new Error("Nome inválido");
    if (!empresa) throw new Error("Nome da empresa inválido");
    if (!email) throw new Error("E-mail inválido");
    if (!telefone) throw new Error("Telefone inválido");
    return new LeadModel(nome ?? "", empresa ?? "", email ?? "", telefone ?? "");
  }
}